module.exports = __webpack_public_path__ + "img/wave-triangle.bfb61aad.svg";